import { render, staticRenderFns } from "./eleveWidget.vue?vue&type=template&id=fb13a952&scoped=true&lang=pug&"
import script from "./eleveWidget.vue?vue&type=script&lang=js&"
export * from "./eleveWidget.vue?vue&type=script&lang=js&"
import style0 from "./eleveWidget.vue?vue&type=style&index=0&id=fb13a952&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb13a952",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VList,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle})
